module.exports = __webpack_public_path__ + "img/science-grey.464b5033.svg";